import { experimentalMutate } from '@confluence/legacy-schema-bridge/entry-points/experimentalMutate';
import { MediaType } from '@confluence/graphql/entry-points/MediaType';
import { fg } from '@confluence/feature-gating';

export const experimentalFileUploadMutate = ({ variables }) => {
	if (fg('confluence_comment_use_comment_media_endpoint')) {
		// Hard disable drag-and-drop upload functionality
		return;
	}

	void experimentalMutate<
		FileUploadMutation,
		FileUploadMutationVariables,
		FileUploadMutationResponse
	>({
		url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
		method: 'POST',
		body: JSON.stringify(variables),
		headers: {
			'Content-Type': MediaType.JSON,
		},
		variables,
		parseResult: () => ({
			experimentalFileUpload: variables,
		}),
	});
};
interface FileUploadMutation {
	experimentalFileUpload: boolean | null;
}
interface FileUploadMutationVariables {
	size: number;
	contentType: string;
	mimeType: string;
	fileName: string;
	pageId: string;
	fileStoreId: string;
	minorEdit?: boolean | null;
	renderEditorHTML?: boolean | null;
	collectionName: string;
	uploadSource?: string | null;
}
interface FileUploadMutationResponse {
	id: string;
	htmlForEditor: string;
}
